import Vue from 'vue'
import VueRouter from 'vue-router'
import Map from '../views/Map.vue'
import Filter from '../components/sidenav/Filter.vue'
import Single from '../components/sidenav/Single.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/' + window.mmconfig.slug + '/' },
  {
    path: '/' + window.mmconfig.slug + '/',
    component: Map,
    children: [
      {
        path: '',
        component: Filter
      },
      {
        path: ':id',
        component: Single,
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: routes
})

export default router